import { render, staticRenderFns } from "./MainClinicCust.vue?vue&type=template&id=3011405d&scoped=true&"
import script from "./MainClinicCust.vue?vue&type=script&lang=js&"
export * from "./MainClinicCust.vue?vue&type=script&lang=js&"
import style0 from "./MainClinicCust.vue?vue&type=style&index=0&id=3011405d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3011405d",
  null
  
)

export default component.exports